type OPERATION = 'connectOnProjectPage';

const pathMap = {
  connectOnProjectPage: 'connect',
};

// the deep link for the electron app
// for example
//     usage: openInElectronApp('connectOnProjectPage', '/@Daomaster/xxxx')
//            it will be converted to 'wikifactory://connect/@Daomaster/xxxx'
//            then in the electron app, it will be converted to 'https://wikifactory.com/@Daomaster/xxxx'
const openInElectronApp = (
  operation: OPERATION,
  deepLinkPath: string,
  onWakeUpFailed: () => void,
) => {
  const link = document.createElement('a');
  link.href = `${DEEP_LINK_PROTOCOL}://${pathMap[operation]}${deepLinkPath}`;
  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    if (document.hasFocus()) {
      onWakeUpFailed?.();
    }
  }, 400);

  document.body.removeChild(link);
};

export { openInElectronApp };
